import { render, staticRenderFns } from "./InformationBuilding.vue?vue&type=template&id=dd064fae&scoped=true"
import script from "./InformationBuilding.vue?vue&type=script&lang=js"
export * from "./InformationBuilding.vue?vue&type=script&lang=js"
import style0 from "./InformationBuilding.vue?vue&type=style&index=0&id=dd064fae&prod&scoped=true&lang=css"
import style1 from "./InformationBuilding.vue?vue&type=style&index=1&id=dd064fae&prod&lang=css"
import style2 from "./InformationBuilding.vue?vue&type=style&index=2&id=dd064fae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd064fae",
  null
  
)

export default component.exports